import * as moment from 'moment';

export class Review {
    id: number;
    user_id: number;
    course_id: number;
    review: string;
    rating: number;
    updated_at: moment.Moment;
    created_at: moment.Moment;
    user: any;
    status: string;
    constructor(review?) {
        if (review) {
            this.id = review.id;
            this.user_id = review.user_id;
            this.course_id = review.course_id;
            this.review = review.review;
            this.rating = review.rating;
            this.created_at = moment(review.created_at);
            this.updated_at = moment(review.updated_at);
            this.user = review.user;
            this.status=review.status;
        }
    }
}
